// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.table-responsive {
  overflow-x: auto;
  overflow-y: hidden;
  border-radius: 10px;
}
.table-responsive table.items {
  background: var(--ion-item-background);
  width: 100%;
}
.table-responsive table.items tr th {
  background: #7EE2BE;
  color: #000;
}
.table-responsive table.items tr th, .table-responsive table.items tr td {
  padding: 8px 10px;
  white-space: nowrap;
  text-align: left;
}
.table-responsive table.items tr td {
  font-family: "Roboto";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 16px;
}
.table-responsive table.items tr td ion-input {
  border: 1px solid var(--ion-item-border-color);
  border-radius: 10px;
  background: var(--ion-item-background);
  --padding-start: 10px;
  --padding-end: 10px;
}
.table-responsive table.items tr td span {
  font-family: "Roboto";
  font-style: normal;
  font-weight: 400;
  font-size: 11px;
  line-height: 13px;
  color: #747889;
}

ion-row ion-col:nth-child(2) {
  text-align: right;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/admin/credit_notes/modals/apply-to-invoice/apply-to-invoice.page.scss"],"names":[],"mappings":"AAAA;EACI,gBAAA;EACA,kBAAA;EACA,mBAAA;AACJ;AAAI;EACI,sCAAA;EACA,WAAA;AAER;AAAY;EACI,mBAAA;EACA,WAAA;AAEhB;AAAY;EACI,iBAAA;EACA,mBAAA;EACA,gBAAA;AAEhB;AAAY;EACI,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;AAEhB;AADgB;EACI,8CAAA;EACA,mBAAA;EACA,sCAAA;EACA,qBAAA;EACA,mBAAA;AAGpB;AAAY;EACI,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EAEA,cAAA;AAChB;;AAMI;EACI,iBAAA;AAHR","sourcesContent":[".table-responsive {\n    overflow-x: auto;\n    overflow-y: hidden;\n    border-radius: 10px;\n    table.items {\n        background: var(--ion-item-background);\n        width: 100%;\n        tr {\n            th {\n                background: #7EE2BE;\n                color: #000;\n            }\n            th, td {\n                padding: 8px 10px;\n                white-space: nowrap;\n                text-align: left;\n            } \n            td {\n                font-family: 'Roboto';\n                font-style: normal;\n                font-weight: 400;\n                font-size: 14px;\n                line-height: 16px;\n                ion-input {\n                    border: 1px solid var(--ion-item-border-color);\n                    border-radius: 10px;\n                    background: var(--ion-item-background);\n                    --padding-start: 10px;\n                    --padding-end: 10px;\n                }\n            }\n            td span {\n                font-family: 'Roboto';\n                font-style: normal;\n                font-weight: 400;\n                font-size: 11px;\n                line-height: 13px;\n\n                color: #747889;\n            }\n        }\n    }\n}\n\nion-row {\n    ion-col:nth-child(2) {\n        text-align: right;\n    }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
